<template>
  <div class="category-editor">
    <!-- Existing Categories -->
    <div v-for="cat in safeCategories" :key="cat.id" class="category-row">
      <div class="category-tag-wrapper">
        <span class="category-tag"
              :style="{ backgroundColor: cat.background_color, color: '#fff' }">
          {{ cat.name }}
        </span>
      </div>
      <button class="btn-delete" @click="deleteCategory(cat.id)" title="Löschen">
        <i class="fas fa-trash text-muted"></i>
      </button>
    </div>

    <!-- Add New Category Row -->
    <div class="category-row add-row">
      <div class="category-input-wrapper">
        <input type="color" 
               v-model="newCategoryColor"
               class="color-picker"
               title="Farbe wählen"/>
        <input type="text" 
               v-model="newCategoryName" 
               placeholder="Neue Kategorie eingeben..."
               class="form-control category-input" 
               @keyup.enter="addNewCategory"/>
      </div>
      <button class="btn btn-success btn-sm" 
              @click="addNewCategory"
              :disabled="!newCategoryName.trim()" 
              title="Kategorie hinzufügen">
        <i class="fas fa-plus"></i>
      </button>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'CategoryEditor',
  emits: [],
  props: {
    current_group_id: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      newCategoryName: '',
      newCategoryColor: '#27ae60'
    };
  },
  computed: {
    safeCategories() {
      return this.$store.state.transaction_categories;
    }
  },
  mounted() {
    // Load categories if not already loaded
    if (this.$store.state.transaction_categories.length === 0) {
      this.$store.dispatch('loadTransactionCategories');
    }
  },
  watch: {
    current_group_id(newGroupId, oldGroupId) {
      // Trigger loadTransactionCategories whenever current_group_id changes
      if (newGroupId !== oldGroupId) {
        this.$store.dispatch('loadTransactionCategories');
      }
    }
  },
  methods: {
    addNewCategory() {
      if (!this.newCategoryName.trim()) {
        return;
      }

      console.log('Adding category:', {
        name: this.newCategoryName.trim(),
        color: this.newCategoryColor
      });
      let credentials = JSON.parse(localStorage.getItem('credentials'))
      const data = new FormData();
      data.append('category_name', this.newCategoryName.trim());
      data.append('background_color', this.newCategoryColor);
      data.append('group_id', this.$store.state.current_group.id);
      axios({
        url: process.env.VUE_APP_ROOT_API + '/transaction_categories',
        data: data,
        auth: credentials,
        method: 'post'
      }).then(resp => {
        this.$store.dispatch('loadTransactionCategories')
        let msg = resp.data
        console.log("Message")
        console.log(msg)
        if (msg !== null) {
          console.log("Pushing result message to store")
          this.$store.commit('add_message', msg)
          if (msg.type !== "ERROR") {
            this.newCategoryName = '';
            this.newCategoryColor = '#27ae60';
          }
        }
      }).catch(error => {
        console.error('Error adding category:', error);
        this.$store.commit('add_message', {
          type: 'ERROR',
          text: 'Fehler beim Hinzufügen der Kategorie.'
        });
      });

      // Clear the form
      this.newCategoryName = '';
      this.newCategoryColor = '#27ae60';
    },
    deleteCategory(categoryId) {
      if (!confirm('Kategorie löschen?')) {
        return;
      }
      console.log('Deleting category:', categoryId);
      let credentials = JSON.parse(localStorage.getItem('credentials'));
      axios({
        url: process.env.VUE_APP_ROOT_API + '/transaction_categories/' + categoryId,
        auth: credentials,
        method: 'delete'
      }).then(resp => {
        this.$store.dispatch('loadTransactionCategories')
        let msg = resp.data
        console.log("Message")
        console.log(msg)
        if (msg !== null) {
          console.log("Pushing result message to store")
          this.$store.commit('add_message', msg)
        }
      }).catch(error => {
        console.error('Error deleting category:', error);
        this.$store.commit('add_message', {
          type: 'ERROR',
          text: 'Fehler beim Löschen der Kategorie.'
        });
      });
    }
  }
};
</script>
<style scoped>
.category-editor {
  width: 100%;
}

.category-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #e9ecef;
}

.category-row:last-child {
  border-bottom: none;
}

.category-tag-wrapper {
  flex: 1;
}

.category-tag {
  display: inline-block;
  padding: 8px 20px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 0.95rem;
}

.btn-delete {
  background: none;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.btn-delete:hover {
  opacity: 0.7;
}

.btn-delete i {
  font-size: 1.1rem;
}

.add-row {
  padding-top: 16px;
}

.category-input-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  margin-right: 12px;
}

.color-picker {
  width: 40px;
  height: 38px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  cursor: pointer;
  padding: 2px;
}

.category-input {
  flex: 1;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 0.95rem;
}

.category-input:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-success {
  padding: 8px 16px;
}

.text-muted {
  color: #6c757d !important;
}
</style>